function DatePickerModal({ onClose, onContinue, onBack, selectedDate, onDateChange, isCompleting }) {
    // Get the start of the current week (Monday)
    const getStartOfWeek = (date) => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        const day = d.getDay();
        // If Sunday (0), go back 6 days to get to Monday
        // Otherwise, go back (day - 1) days
        const diff = day === 0 ? 6 : day - 1;
        d.setDate(d.getDate() - diff);
        return d;
    };
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const startOfCurrentWeek = getStartOfWeek(today);
    
    const handleDateChange = (e) => {
        const date = e.target.value;
        if (!date) {
            onDateChange(date);
            return;
        }
        
        const selectedDateObj = new Date(date + 'T00:00:00');
        selectedDateObj.setHours(0, 0, 0, 0);
        
        // Check if selected date is a Sunday
        if (selectedDateObj.getDay() === 0) {
            alert('Sundays are rest days! Please select a different day.');
            return;
        }
        
        // Check if date is before the current week (locked)
        if (selectedDateObj < startOfCurrentWeek) {
            alert('Previous weeks are locked. You can only log workouts for the current week.');
            return;
        }
        
        // Check if date is in the future
        if (selectedDateObj > today) {
            alert('You cannot log workouts for future dates.');
            return;
        }
        
        onDateChange(date);
    };
    
    // Min date is start of current week (Monday)
    const minDate = startOfCurrentWeek.toISOString().split('T')[0];
    const maxDate = today.toISOString().split('T')[0];

    return (
        <div className="modal-overlay">
            <div className="modal-container tw-items-center tw-text-center" onClick={(e) => e.stopPropagation()}>
                <button 
                    onClick={onClose}
                    className="tw-absolute tw-top-6 tw-right-6 tw-bg-transparent tw-border-0 tw-text-5xl tw-cursor-pointer tw-text-gray-400 hover:tw-text-black"
                >
                    ×
                </button>

                <h1 className="modal-title tw-mb-4">
                    Select a Date
                </h1>
                
                <p className="modal-text tw-text-xl tw-mb-8 tw-font-['Poppins']">
                    Choose which day you completed this workout
                </p>
                
                <input 
                    type="date"
                    value={selectedDate || ''}
                    min={minDate}
                    max={maxDate}
                    onChange={handleDateChange}
                    disabled={isCompleting}
                    className="tw-w-full tw-p-4 tw-text-xl tw-border-2 tw-border-black tw-rounded-lg tw-mb-4"
                    style={{
                        fontFamily: 'Poppins',
                        fontWeight: 600
                    }}
                />
                
                <button 
                    onClick={onContinue}
                    disabled={isCompleting || !selectedDate}
                    className="btn-primary tw-mb-4"
                >
                    CONTINUE
                </button>
                
                <button 
                    onClick={onBack}
                    disabled={isCompleting}
                    className="btn-secondary"
                >
                    BACK
                </button>
            </div>
        </div>
    );
}

export default DatePickerModal;
